import type { DevicePreset } from '@/types/feedback';
import type { useTranslations } from 'next-intl';

type TranslateFn = ReturnType<typeof useTranslations>;

const DEVICE_LABEL_KEYS: Record<DevicePreset, string> = {
  mobile: 'get-feedback-toolbar-mobile',
  desktop: 'get-feedback-toolbar-desktop',
};

export function getDeviceLabel(device: DevicePreset, t: TranslateFn): string {
  return t(DEVICE_LABEL_KEYS[device]);
}
